import React from "react";

export const MonitorIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

export const RobotIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="8" width="14" height="12" rx="2" ry="2" />
    <line x1="12" y1="3" x2="12" y2="8" />
    <circle cx="12" cy="2.5" r="0.6" />
    <circle cx="10" cy="13" r="1" />
    <circle cx="14" cy="13" r="1" />
    <line x1="9" y1="17" x2="15" y2="17" />
    <line x1="2" y1="13" x2="5" y2="13" />
    <line x1="19" y1="13" x2="22" y2="13" />
  </svg>
);

export const PenIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);

export const GolfIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <line x1="8" y1="4" x2="8" y2="20" />
    <path d="M8 4 L18 7 L8 10 Z" />
    <line x1="4" y1="20" x2="20" y2="20" />
  </svg>
);

export const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

export const BirdIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 14 C6 8 9 8 12 14 C15 8 18 8 21 14" />
  </svg>
);
